import { BrokenImage } from '@components/index';
import styled from 'styled-components';

export const Overlay = styled.div`
  /* Layout Properties */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  position: fixed;
  align-content: center;
  justify-content: center;
  z-index: 10;
  /* UI Properties */
  background: #0000003d 0 0 no-repeat padding-box;
  opacity: 1;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
`;

export const Container = styled.div`
  padding: 24px;
  width: 100%;
  max-width: 960px;
  height: fit-content;
  max-height: 100%;
  align-self: center;
  justify-self: center;
  z-index: 10;
  position: fixed;
  background: #ffffff 0 0 no-repeat padding-box;
  box-shadow: 0 12px 28px rgba(33, 39, 73, 0.2);
  border-radius: 8px;
  opacity: 1;
  animation: show 0.2s;
  transform: scale(1);
  display: flex;
  flex-direction: column;

  @keyframes show {
    from {
      transform: scale(0);
      opacity: 0;
      z-index: -1;
    }
    to {
      transform: scale(1);
      opacity: 1;
      z-index: 2;
    }
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  span {
    display: inline-flex;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    border-radius: 8px;
    width: 32px;
    height: 32px;

    transition: 0.2s;

    :hover {
      background-color: #f6f8ff;
    }
  }
`;

export const Title = styled.h3`
  font-weight: 600;
  font-size: 18px;
  line-height: 24px;
  color: #1b203a;
`;

export const Row = styled.div`
  display: flex;
  gap: 24px;
`;

export const Grid = styled.div`
  flex: 1;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(30%, 1fr));
  column-gap: 24px;
  row-gap: 16px;
`;

export const InfoContainer = styled.div``;

export const Label = styled.label`
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #8f95b2;
`;

export const Text = styled.p`
  margin: unset;
  margin-top: 6px;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #1b203a;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
`;

export const EmptyText = styled.p`
  margin: unset;
  margin-top: 6px;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #1b203a;
  opacity: 0.6;
  font-style: italic;
`;

export const LinkText = styled.a`
  display: block;
  margin-top: 6px;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  text-decoration-line: underline;
  color: #1371fe;
  cursor: pointer;

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;

  :hover {
    opacity: 0.8;
  }
`;

export const ProductImage = styled(BrokenImage)`
  width: 130px;
  min-width: 130px;
  height: 130px;
  border: 1px solid #d8dae5;
  border-radius: 4px;
  border-radius: 4px;
  object-fit: cover;
  margin-right: 24px;
  padding: 12px;
`;

export const LifeCycleWrapper = styled.div`
  display: flex;
  column-gap: 6px;
  margin-top: 6px;

  svg {
    margin-top: 4px;
  }
`;

export const LifeCycleText = styled.p`
  margin: unset;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #474d66;
`;

export const Bottom = styled.div`
  margin-top: 24px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
`;

export const DescriptionSection = styled.div``;

export const DescriptionText = styled.div`
  margin: unset;
  padding-right: 10px;
  margin-top: 16px;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #474d66;
  overflow-y: auto;
  height: 100%;
`;

export const EmptyDescriptionText = styled.div`
  height: 100%;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #1b203a;
  opacity: 0.6;
  margin-top: 16px;
  font-style: italic;
`;

export const SearchSection = styled.div`
  padding: 0px 16px;
  border-left: 1px solid #e6e8f0;
`;

export const ProductSpecContainer = styled.div`
  height: fit-content;
  height: 364px;
  max-height: 364px;
  overflow-y: auto;
  margin-top: 16px;
`;

export const EmptyProductDetails = styled.div`
  height: 590px;
  max-height: 570px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;
